import '../../../../../../vendor/assets/javascripts/waypoints.min';

window.Reverb = window.Reverb || {};

Reverb.BlogNavigation = (function () {
  var body = 'body';
  var activeNavClass = 'active';
  var blogHeader = '.blog-header';

  function init() {
    handleNavigationTrigger();
  }

  function handleNavigationTrigger() {
    if (Reverb.MobileDetection.isMobileBrowser()) return false; // stopping function when on mobile

    $(blogHeader).waypoint(displayFixedNavigation, {
      offset: function () {
        return -$(this).height();
      }
    });
  }

  function displayFixedNavigation(direction) {
    if (direction === 'down')
      $(this).addClass(activeNavClass);
    else
      $(this).removeClass(activeNavClass);
  }

  return {
    init: init
  };
})();

$(Reverb.BlogNavigation.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/blog/blog_navigation.js